import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  loggedUser = {
    name: 'Jane Doe',
    photo: '',
  };

  isLogged = false;


  constructor(public router: Router) {}



  ngOnInit(): void {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      this.isLogged = true;
    }else{
      this.isLogged = false;
    }
  }

}
